export default function CategorySection({ title, items, checkedItems, onToggle }) {
  return (
    <details open style={{ marginBottom: "10px" }}>
      <summary style={{ fontWeight: "bold", fontSize: "16px" }}>{title}</summary>
      <ul>
        {items.map((item, idx) => {
          const id = `${title}-${idx}`; // unique ID
          return (
            <li key={id}>
              <input
                type="checkbox"
                id={id}
                checked={!!checkedItems[id]}   // ✅ controlled state
                onChange={(e) => onToggle(id, e.target.checked)}
              />
              <label htmlFor={id}>{item}</label>
            </li>
          );
        })}
      </ul>
    </details>
  );
}
